import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  useCouponByIdRelayQuery,
  mapCouponToICoupon,
} from '../../../hooks/coupons/query/V2';
import { ICoupon } from '../../../ts/interface/coupon.interface';
import { findAccess } from '../../../utils';
import { IAuth } from '../../../ts/interface/admins.interface';
import CouponForm from '../../../components/coupons/CouponForm';
import useOrganization from '../../../hooks/use-organization';

const OrganizationCouponEdit = ({
  systemAccess,
  movaticAccess,
}: {
  movaticAccess: number;
  systemAccess: number;
}) => {
  const { couponId } = useParams<{ couponId: string }>();
  const organizationInfo = useOrganization();
  const organizationId = organizationInfo?.id ?? '';
  const organizationAccess = organizationInfo?.access ?? systemAccess;

  const { data: couponData, isLoading } = useCouponByIdRelayQuery(couponId, {
    enabled: !!couponId,
  });
  const coupon: ICoupon | undefined = couponData
    ? mapCouponToICoupon(couponData)
    : undefined;

  const saveDisabled =
    !findAccess(organizationAccess as number).includes('rates') && !movaticAccess;

  return (
    <CouponForm
      key={coupon?.id ?? 'loading'}
      scope="org"
      mode="edit"
      systemLoaded={!isLoading}
      initialValues={coupon}
      couponId={couponId}
      organizationId={organizationId}
      cancelHref={`/organization/billing/coupon/${couponId}`}
      successHref={`/organization/billing/coupon/${couponId}`}
      saveDisabled={saveDisabled}
      title="Edit Organization Coupon"
    />
  );
};

export default connect(
  (state: {
    admin: {
      admin: IAuth;
      systemAccess: number;
    };
  }) => ({
    movaticAccess: state.admin.admin.admin.movaticAccess,
    systemAccess: state.admin.systemAccess,
  }),
  () => ({})
)(OrganizationCouponEdit);
